exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.home-care-table ul li[data-v-1b2d99e3] {\n  line-height: 20px ;\n  list-style: none;\n}\n", ""]);

// exports
